import { useTranslation } from "react-i18next";
import { IOutletContext } from "../utils/interfaces/IOutletContext";
import { useOutletContext } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../utils/redux/userSlice";
import ReportingButtonsLine from "../components/ReportingButtonsLine/ReportingButtonsLine.component";
import { getMachinesByCompany } from "../utils/services/machine.service";
import { Machine } from "../utils/models/Machine";
import { ISelectOptions } from "aw-combobox";
import { getRandomNumber, orderByLabel } from "aw-generic-functions";
import ReportViewer from "../components/ReportViewer/ReportViewer.component";

const ReportingModulePage = () => {
  const { t } = useTranslation();
  const user = useSelector(selectUser)
  const context: IOutletContext = useOutletContext();
  const [allMacines, setAllMachines] = useState(false)
  const [machines, setMachines] = useState<Machine[]>([])
  const [machine, setMachine] = useState<Machine>(new Machine())
  const [machinesOptions, setMachinesOptions] = useState<ISelectOptions[]>([])
  const [machineSelected, setMachineSelected] = useState<ISelectOptions>()
  const [loading, setLoading] = useState(false)
  const [month, setMonth] = useState(new Date().getMonth())
  const [year, setYear] = useState(new Date().getFullYear())
  const [itemsChar, setItemsChar] = useState('')
  const [profitsChar, setProfitsChar] = useState('')
  const [alarmsChart, setAlarmsChart] = useState('')

  const [errorsMonth] = useState(getRandomNumber(2, 20))
  const [errorsTotal] = useState(getRandomNumber(2, 20))
  const [productsMonth] = useState(getRandomNumber(50, 150))
  const [productsTotal] = useState(getRandomNumber(200, 600))
  const [productivityMonth] = useState(getRandomNumber(70, 100))
  const [productivityTotal] = useState(getRandomNumber(70, 100))

  const [itemsPerDay, setItemsPerDay] = useState<{ date: string; numItems: number }[]>([])

  useEffect(() => {
    context.setState(t('ReportsAndBilling'))
  })

  useEffect(() => {
    getMachinesByCompany(user.token, user.company.idcompany)
      .then((machines: Machine[]) => {
        if (machines.length === 0) { throw new Error('No Machines') }
        const allMachinesObjAux: ISelectOptions[] = []
        const machinesAux: Machine[] = []

        machines.forEach((m: Machine) => {
          allMachinesObjAux.push({ label: m.name, value: m.idmachine })
          machinesAux.push(m)
        })

        const machinesObjOrd = orderByLabel(allMachinesObjAux)
        setMachinesOptions(machinesObjOrd)

        setMachines(machinesAux)
        setMachine(machinesAux.find((m: Machine) => m.idmachine === machinesObjOrd[0].value) || machinesAux[0])
        setMachineSelected(machinesObjOrd[0])

      }).catch((e) => {
        console.error('Get UserMachines', e)
      })
  }, [])

  const onChangeMachineFilter = (v: any) => {
    setMachineSelected(v)
    const machine = machines.find((m: Machine) => m.idmachine === v.value)
    if (machine) setMachine(machine)
  }

  const onClickGenerate = () => {
    setLoading(true)
    setTimeout(() => setLoading(false), 1000)
  }

  const onChangeMonth = (e: any) => {
    setMonth(e.value)
  }

  const onChangeYear = (e: any) => {
    setYear(e.value)
  }

  const onCheckChange = () => {
    setAllMachines((prevValue) => !prevValue)
  }

  return (
    <>
      <div className='row border-0 mx-1  mt-2' style={{ maxWidth: '100%' }}>
        <div className='col-12'>
          <ReportingButtonsLine
            onChangeMachineFilter={onChangeMachineFilter}
            onClickGenerate={onClickGenerate}
            machineSelected={machineSelected}
            machinesOptions={machinesOptions}
            machine={machine}
            onChangeMonth={onChangeMonth}
            onChangeYear={onChangeYear}
            selectedMonth={month}
            selectedYear={year}
            onCheckChange={onCheckChange}
            alarmsChart={alarmsChart}
            profitsChar={profitsChar}
            itemsChar={itemsChar}
            errorsMonth={errorsMonth}
            errorsTotal={errorsTotal}
            productivityMonth={productivityMonth}
            productivityTotal={productivityTotal}
            productsMonth={productsMonth}
            productsTotal={productsTotal}
            itemsPerDay={itemsPerDay}
          />
        </div>
      </div>
      <div className="row border-0 mx-1">
        <div className='col-12'>
          <ReportViewer
            allMachinesChecked={allMacines}
            user={user}
            alarmsForDay={setAlarmsChart}
            profitsForDay={setProfitsChar}
            itemsForDay={setItemsChar}
            machine={machine}
            month={month}
            refresh={loading}
            token={user.token}
            year={year}
            errorsMonth={errorsMonth}
            errorsTotal={errorsTotal}
            productivityMonth={productivityMonth}
            productivityTotal={productivityTotal}
            productsMonth={productsMonth}
            productsTotal={productsTotal}
            onItemsPerDayData={setItemsPerDay}
          />
        </div>
      </div>
    </>
  )
}

export default ReportingModulePage;
